import { render, staticRenderFns } from "./RentalCardV5.vue?vue&type=template&id=55a481f7&scoped=true"
import script from "./RentalCardV5.vue?vue&type=script&lang=js"
export * from "./RentalCardV5.vue?vue&type=script&lang=js"
import style0 from "./RentalCardV5.vue?vue&type=style&index=0&id=55a481f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a481f7",
  null
  
)

export default component.exports